import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApiService } from "./services/api.service";
import { JwtService } from "./services/jwt.service";
import { UserService } from "./services/user.service";
import {AuthGuard} from "./services/auth-guard.service";
import {NoAuthGuard} from "./services/no-auth-guard.service";
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import {HttpTokenInterceptor} from "./interceptors";


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: HttpTokenInterceptor, multi: true },
    ApiService,
    JwtService,
    UserService,
    AuthGuard,
    NoAuthGuard
  ]
})
export class CoreModule { }
